module.exports = __webpack_public_path__ + "img/product2.182ca864.png";